export default __webpack_public_path__ + "static/media/scenarios_icon.fae3299c.svg";